export default {
    methods: {
      /*
       * @description 时间格式化
       * @param { date } date 时间或时间戳
       * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
       *
       * @return { string } 格式化后的字符串
      */
      dateFormatString (date, format) { // 时间格式化
        var date = new Date(date),
            o = {
              "M+" : date.getMonth() + 1,
              "d+" : date.getDate(),
              "h+" : date.getHours(),
              "m+" : date.getMinutes(),
              "s+" : date.getSeconds(),
              "q+" : Math.floor((date.getMonth() + 3) / 3),
              "S" : date.getMilliseconds()
            };
        
        if (/(y+)/.test(format)) {
          format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
          }
        }
        return format;
      },
      /*
       * @description 获取文件后缀名
       * @param { string } file 文件url地址
       *
       * @return { string } 文件后缀名
      */
      getSuffix (file) { // 获取文件后缀名
        var lastPlace = file.lastIndexOf("."),
            fileLength = file.length;
  
        return file.substring(lastPlace + 1, fileLength)    
      },
  
      /*
       * @description 将秒格式化
       * @param { number } seconds 秒数
       * @param { string } format 格式化的字符串 eg: 'hh:mm:ss'
       *
       * @return { string } 格式化后的字符串
      */
      formatSeconds (seconds, format) { // 将秒格式化
        var o;
        
        if ( format.indexOf('h') != -1 ) {
          o = {
            'h+': Math.floor(seconds / 3600),
            'm+': Math.floor(seconds / 60) % 60,
            's+': Math.floor(seconds) % 60
          }
        } else {
          o = {
            'm+': Math.floor(seconds / 60),
            's+': Math.floor(seconds) % 60
          }
        }
  
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length > 1 ? 2 : 1));
          }
        }
        return format;    
            
      },
      /*
       * @description 数组深拷贝
       * @param { array } 需要拷贝的数组
       *
       * @return { array } 拷贝后的数组
      */
      coppyArray(arr){
        return arr.map((e)=>{
                  if (typeof e==='object') {
                    return Object.assign({},e);
                  } else {
                     return e;
                    }
               }) 
      },
      /* 
       * @description 将json格式的对象拼接成复杂的url参数
       * @param { object } param  将要转为URL参数字符串的对象 
       * @param { string } key URL参数字符串的前缀 
       * @param { boolean } encode 是否进行URL编码,默认为true 
       *  
       * @return { string } URL参数字符串 
      */  
      urlEncode (param, key, encode) {  
        if ( param == null ) return '';  
        var paramStr = '';  
        var t = typeof param;  
        if ( t == 'string' || t == 'number' || t == 'boolean' ) {  
          paramStr += '&' + key + '=' + ((encode==null||encode) ? encodeURIComponent(param) : param);  
        } else {  
          for (var i in param) {  
            var k = key == null ? i : key + (param instanceof Array ? '[' + i + ']' : '.' + i);  
            paramStr += this.urlEncode(param[i], k, encode);  
          }  
        }  
        return paramStr;  
      },
      /*
       * @desciprtion  删除url地址参数
       * @param { string } url url地址
       * @param { string } name 需要删除的参数
       *
       * @return  { string } 删除参数后的url地址
      */
      delUrlParam (url, name) {
        var str = "";
        var arr = "";
        var returnurl = "";
        var setparam = "";
  
        if (url.indexOf('?') != -1) {
            str = url.substr(url.indexOf('?') + 1);
        } else {
            return url;
        }
  
        if (str.indexOf('&') != -1) {
            arr = str.split('&');
            for (var i in arr) {
                if (arr[i].split('=')[0] != name) {
                    returnurl = returnurl + arr[i].split('=')[0] + "=" + arr[i].split('=')[1] + "&";
                }
            }
            return url.substr(0, url.indexOf('?')) + "?" + returnurl.substr(0, returnurl.length - 1);
        } else {
            arr = str.split('=');
            if (arr[0] == name) {
                return url.substr(0, url.indexOf('?'));
            }
            else {
                return url;
            }
        }
      },
      /** 
       * @description 过滤数组中的空值
       * @param { array } arr 需要过滤的数组 
       * @return { array } [] 
       */  
      clearArrTrim (arr)  {  
        for ( var i = 0; i < arr.length; i++ ) {  
          if ( typeof arr[i] == 'undefined' || arr[i] == '') {  
              arr.splice(i, 1);  
              i = i-1;  
          }  
        }  
        return arr; 
      },
      /** 
       * @description 判断数组是否有重复元素
       * @param { array } arr 需要判断的数组 
       * @return { boolean } 
       */ 
      arrayIsRepeat (arr) {
        var hash = {};
        for ( var i in arr ) {
          if ( hash[arr[i]] ) {
            return arr[i];
          }
          hash[arr[i]] = true;
        }
        return false;
      },
      /** 
       * @description 保留两位小数(少于两位不会补0)
       * @param { number } num 需要转换的数字
       * @return { number }  
       */ 
      toDecimal2NoZero(num) {
        return Number(( Math.round( num * 100 ) / 100 ).toString());
      },
      /*
       * @description 获取cookie
       * @param { string } cname 需要获取的cookie
       * @return { string }
      */
      getCookie ( cname ) {
        var name = cname + '=';
        var ca = document.cookie.split(';');
        for( var i = 0; i < ca.length; i++ ) {
            var c = ca[i];
            while ( c.charAt(0) == ' ' ) c = c.substring(1);
            if ( c.indexOf(name) != -1 ) return c.substring(name.length, c.length);
        }
        return '';
      },
      /**
       * 获取本周、本季度、本月、上月的开端日期、停止日期
       */
      getCurrentDate() {
          let now = new Date(); //当前日期
          let nowDayOfWeek = now.getDay(); //今天本周的第几天
          let nowDay = now.getDate(); //当前日
          let nowMonth = now.getMonth(); //当前月
          let nowYear = now.getYear(); //当前年
          nowYear += (nowYear < 2000) ? 1900 : 0; 
          let lastMonthDate = new Date(); //上月日期 
          lastMonthDate.setDate(1); 
          lastMonthDate.setMonth(lastMonthDate.getMonth()-1); 
          let lastYear = lastMonthDate.getYear(); 
          let lastMonth = lastMonthDate.getMonth();
          return {
              weekStartDate: this.getWeekStartDate(nowYear, nowMonth, nowDay, nowDayOfWeek),
              weekEndDate: this.getWeekEndDate(nowYear, nowMonth, nowDay, nowDayOfWeek),
              monthStartDate: this.getMonthStartDate(nowYear, nowMonth),
              monthEndDate: this.getMonthEndDate(nowYear, nowMonth),
              lastMonthStartDate: this.getLastMonthStartDate(nowYear, lastMonth),
              lastMonthEndDate: this.getLastMonthEndDate(nowYear, lastMonth)
          }
  
      },
  
      //获得本季度的开端月份 
      getQuarterStartMonth(nowMonth){ 
          var quarterStartMonth = 0; 
          if(nowMonth<3){ 
              quarterStartMonth = 0; 
          } 
          if(2<nowMonth && nowMonth<6){ 
              quarterStartMonth = 3; 
          } 
          if(5<nowMonth && nowMonth<9){ 
              quarterStartMonth = 6; 
          } 
          if(nowMonth>8){ 
              quarterStartMonth = 9; 
          } 
          return quarterStartMonth; 
      },
  
      //获得某月的天数
      getMonthDays(nowYear, myMonth){
          let monthStartDate = new Date(nowYear, myMonth, 1);
          let monthEndDate = new Date(nowYear, myMonth + 1, 1);
          let days = (monthEndDate - monthStartDate)/(1000 * 60 * 60 * 24);
          return days;
      },
  
      //获得本周的开端日期
      getWeekStartDate(nowYear, nowMonth, nowDay, nowDayOfWeek) {
          var weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1);
          return this.dateFormatString(weekStartDate, 'yyyy-MM-dd');
      },
  
      //获得本周的停止日期
      getWeekEndDate(nowYear, nowMonth, nowDay, nowDayOfWeek) {
          var weekEndDate = new Date(nowYear, nowMonth, nowDay + (7 - nowDayOfWeek));
          return this.dateFormatString(weekEndDate, 'yyyy-MM-dd');
      },
  
      //获得本月的开端日期
      getMonthStartDate(nowYear, nowMonth){
          var monthStartDate = new Date(nowYear, nowMonth, 1);
           return this.dateFormatString(monthStartDate, 'yyyy-MM-dd');
      },
  
      //获得本月的停止日期
      getMonthEndDate(nowYear, nowMonth){
          var monthEndDate = new Date(nowYear, nowMonth, this.getMonthDays(nowYear, nowMonth));
           return this.dateFormatString(monthEndDate, 'yyyy-MM-dd');
      },
  
      // 获得上月开端时候 
      getLastMonthStartDate(nowYear, lastMonth){ 
          var lastMonthStartDate = new Date(nowYear, lastMonth, 1); 
          return this.dateFormatString(lastMonthStartDate, 'yyyy-MM-dd'); 
      },
      
      // 获得上月停止时候 
      getLastMonthEndDate(nowYear, lastMonth){ 
          var lastMonthEndDate = new Date(nowYear, lastMonth, this.getMonthDays(nowYear, lastMonth)); 
          return this.dateFormatString(lastMonthEndDate, 'yyyy-MM-dd'); 
      },
      
      // 获得本季度的开端日期 
      getQuarterStartDate(nowYear, nowMonth){
          var quarterStartDate = new Date(nowYear, this.getQuarterStartMonth(nowMonth), 1); 
          return this.dateFormatString(quarterStartDate, 'yyyy-MM-dd'); 
      },
      
      // 获得本季度的停止日期 
      getQuarterEndDate(nowYear, nowMonth){ 
          var quarterEndMonth = this.getQuarterStartMonth(nowMonth) + 2; 
          var quarterStartDate = new Date(nowYear, quarterEndMonth, this.getMonthDays(nowYear, quarterEndMonth)); 
          return this.dateFormatString(quarterStartDate, 'yyyy-MM-dd'); 
      },
  
      /**
       * 获取从今日开始的前 n 天的日期
       */
      getLastDaysFromToday(n){
          let lastDays = new Date().setDate((new Date().getDate() - n));
          let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
          return lastDaysStr;
      },
  
      setSessionStorage () { // 存储startTime，endTime用于页面传递
          var obj = {
              startTime: this.searchForm.startTime,
              endTime: this.searchForm.endTime
          };
          sessionStorage.setItem('params', JSON.stringify(obj));
      },
  
      /**金额进行千分位格式化 并保留两位小数 20000 => 20,000.00 */
      salaryThousandFormat: function(num){
          if(num == 0 || num == 'undefined' || !num || num == ''){
              return num;
          }
          if(typeof num !== 'number'){
              num = Number(num);
          }
          let newNum = num.toFixed(2).toString().split('.');
          newNum[0] = newNum[0].replace(new RegExp('(\\d)(?=(\\d{3})+$)', 'ig'), "$1,");
          return newNum.join('.');
      },
  
      /** 
      * 乘法运算，避免数据相乘小数点后产生多位数和计算精度损失。 
      * 
      * @param num1被乘数 | num2乘数 
      */ 
      numMulti(num1, num2) { 
          var baseNum = 0; 
          try { 
              baseNum += num1.toString().split(".")[1].length; 
          } catch (e) { 
          } 
          try { 
              baseNum += num2.toString().split(".")[1].length; 
          } catch (e) { 
          } 
          return Number(num1.toString().replace(".", "")) * Number(num2.toString().replace(".", "")) / Math.pow(10, baseNum); 
      },
      /** 
      * 除法运算，避免数据相除小数点后产生多位数和计算精度损失。 
      * 
      * @param num1被除数 | num2除数 
      */ 
      numDiv(num1, num2) { 
          var baseNum1 = 0, baseNum2 = 0; 
          var baseNum3, baseNum4; 
          try { 
              baseNum1 = num1.toString().split(".")[1].length; 
          } catch (e) { 
              baseNum1 = 0; 
          } 
          try { 
              baseNum2 = num2.toString().split(".")[1].length; 
          } catch (e) { 
              baseNum2 = 0; 
          } 
          baseNum3 = Number(num1.toString().replace(".", "")); 
          baseNum4 = Number(num2.toString().replace(".", "")); 
          return (baseNum3 / baseNum4) * Math.pow(10, baseNum2 - baseNum1); 
      },
      // des加密请求
      $m_desRequest(url, data) {
        let params = new URLSearchParams();
        params.append('desc', 'cbc');
        params.append('param', this.getDES(data));

        return new Promise((resolve, reject) => {
          this.$http({
            url: url,
            method: 'post',
            data: params,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(res => {
            if (res.data.code == 200) {
              resolve(res);
            } else {
              if (!~url.indexOf('hideErr')) {
                this.$message.error(res.data.msg);
              }
              reject();
            }
          }, err=> {
            reject();
          })
        })
      },
      // 获取加密后的数据
      getDES(obj) {
        let str = obj;
        if (typeof obj == 'object') {
          str = JSON.stringify(obj);
        } else if (typeof obj == 'number') {
          str = obj.toString();
        }

        let key = 'tjhawkeye';
        let keyHex = CryptoJS.enc.Utf8.parse(key);
        let ivHex = CryptoJS.enc.Utf8.parse(key);
        let option = {
          iv: ivHex,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
        let encrypted = CryptoJS.DES.encrypt(str, keyHex, option);
        return encrypted.ciphertext.toString();
      },

    }
  };


// WEBPACK FOOTER //
// ./src/mixins/common.js